import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  HouseIcon,
  StackIcon,
  NotebookIcon,
  MegaphoneIcon,
  ChatCircleTextIcon,
  GearIcon,
  PlusIcon,
  CardsIcon,
} from '@phosphor-icons/react';
import { BottomNavigation, BottomNavigationAction, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Settings2 } from 'lucide-react';



const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const { t } = useTranslation();

  const navItems = [
    { icon: HouseIcon, label: t('navigation.today'), route: '/home' },
    { icon: NotebookIcon, label: t('navigation.journal'), route: '/journal' },
    { icon: PlusIcon, label: t('navigation.new'), route: '/mode-selector' },
    { icon: CardsIcon, label: t('navigation.readings'), route: '/reading-list' },
    { icon: Settings2, label: t('navigation.settings'), route: '/settings' },

  ];

  const currentValue = navItems.findIndex(item => item.route === location.pathname);

  return (
    <>
      <Box sx={{ height: 64 }} aria-hidden="true" />
      <BottomNavigation
        value={currentValue}
        onChange={(event, newValue) => {
          navigate(navItems[newValue].route);
        }}
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          height: 60,
          zIndex: 50,
          backgroundColor: '#F5F3F0', // match header background
          borderTop: `1px solid #C1B6AD`, // muted border
          '& .MuiBottomNavigationAction-root': {
            color: '#A89B91', // muted icon color
            '&.Mui-selected': {
              color: '#A67C6B', // gentle highlight for selected
            },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.75rem',
            '&.Mui-selected': {
              fontSize: '0.75rem',
              fontWeight: 600,
              color: '#A67C6B', // match selected icon color
            },
          },
        }}
      >
        {navItems.map((item, index) => (
          <BottomNavigationAction
            key={item.label}
            /* showLabel={true}
             label={item.label}*/
            icon={
              <item.icon
                style={{
                  width: 20,
                  height: 20,
                  strokeWidth: currentValue === index ? 3 : 2.5,
                  color: currentValue === index ? '#A67C6B' : '#A89B91',
                }}
              />
            }
          />
        ))}
      </BottomNavigation>
    </>
  );
};

export default Navbar;
